import { useTranslation } from "react-i18next";

import { DesignSystemProvider, ErrorTile } from "chameleon/lib/components";

import { sendCustomAction } from "datadog-loader/loader";

export const CriticalError = ({ error }: { error?: unknown }) => {
  const { t } = useTranslation();
  const title = t("errorHandler.title");
  let caption = t("errorHandler.caption");

  if (error === "Encryption is not functioning correctly") {
    caption = t("errorHandler.securityCaption");
    //DATADOG ALERT
    sendCustomAction({ name: "Pay Enc Not Supported" });
  } else {
    sendCustomAction({ name: "Unknown Error" });
  }

  return (
    <div data-testid="critical-error">
      <DesignSystemProvider>
        <ErrorTile title={title} caption={caption} />
      </DesignSystemProvider>
    </div>
  );
};
